import { render, staticRenderFns } from "./NpaAnswers.vue?vue&type=template&id=56045796&scoped=true"
import script from "./NpaAnswers.vue?vue&type=script&lang=js"
export * from "./NpaAnswers.vue?vue&type=script&lang=js"
import style0 from "./NpaAnswers.vue?vue&type=style&index=0&id=56045796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56045796",
  null
  
)

export default component.exports